import React, { useCallback } from 'react';

/**
 Use disclose hook implementation from Native Base
 @see https://docs.nativebase.io/use-disclose#page-title
 @source https://github.com/GeekyAnts/NativeBase/blob/master/src/hooks/useDisclose.ts
 */
export default function useDisclose(initState?: boolean) {
  const [isOpen, setIsOpen] = React.useState(initState || false);
  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);
  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);
  const onToggle = useCallback(() => {
    setIsOpen((state) => !state);
  }, []);

  return {
    isOpen,
    onOpen,
    onClose,
    onToggle,
  };
}
